<template>
    <router-link :to="'/notes'" style="width: 26px" class="grid relative">
        <Icon class="cursor-pointer m-auto w-full" :src="IconSource.Notes"></Icon>
    </router-link>
</template>
